import clienteAxios from "../config/clienteAxios";


export const postConsulta = async (body) => {
    //console.log(body)
    const resp = await clienteAxios.post('/contact/create',
        body);
    return resp;
};